export const pricingPlans = [
	{
		name: "Starter Web Design",
		price: "$999+",
		features: [
			"Custom 5-Page Website",
			"Mobile Responsive Design",
			"Basic SEO Setup",
			"Contact Form Integration",
			"Speed Optimization",
		],
		buttonVariant: "outline",
		badge: null,
	},
	{
		name: "Growth SEO & Marketing",
		price: "$1,500 / mo",
		features: [
			"Comprehensive SEO Audit",
			"Monthly Content Strategy",
			"2 Blog Posts Per Month",
			"Technical SEO Fixes",
			"Keyword Research",
			"Monthly Performance Report",
			"Digital Marketing Strategy",
		],
		buttonVariant: "orange",
		badge: "Most Popular",
	},
	{
		name: "Full Digital Partner",
		price: "Custom",
		features: [
			"Everything in Growth Plan",
			"Custom Web Application Dev",
			"Advanced E-commerce Features",
			"Dedicated Project Manager",
			"Priority Support",
			"Conversion Rate Optimization",
			"Full-Funnel Marketing",
		],
		buttonVariant: "outline",
		badge: null,
	},
];

export const pricingFaqs = [
	{
		question: "What is your pricing model?",
		answer:
			"We offer both fixed-price project quotes and T&M (Time and Materials) engagements, depending on the project scope and flexibility required.",
	},
	{
		question: "Do you require a deposit?",
		answer:
			"Yes, typically we require a 30-50% deposit to kick off the project, with the remaining balance due upon milestones or completion.",
	},
	{
		question: "Are there any hidden costs?",
		answer:
			"We are transparent about our pricing. Any potential extra costs (like 3rd party licenses, hosting, or premium fonts) are discussed upfront.",
	},
	{
		question: "Do you offer refunds?",
		answer:
			"Our refund policy varies by contract type. Generally, deposits are non-refundable once work has commenced. Specific terms are outlined in our service agreement.",
	},
];
